import { makeStyles } from "@material-ui/core";
import { DRAWER_WIDTH, HEADER_HEIGHT } from "../../../../constants";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
  },
  listItem: {
    color: theme.palette.text.secondary,
  },
  parentItem: {
    paddingLeft: "27px",
  },
  toolbarSide: {
    justifyContent: "center",
    width: DRAWER_WIDTH,
    height: HEADER_HEIGHT,
    minHeight: HEADER_HEIGHT,
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      minHeight: "auto",
    },
  },
  drawer: {
    "& .MuiDrawer-paperAnchorDockedLeft": {
      border: "none",
    },
  },
}));
